module.exports = __webpack_public_path__ + "img/accountability-program.ee882711.jpg";